import React, { useState } from "react";
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Help = () => {
  const [message, setMessage] = useState("");
  const phoneNumber = "5591983744682"; // seu número com DDI + DDD, sem espaços
  const sendMessage = () => {
    if (message.trim() === "") {
      alert("Digite uma mensagem antes de enviar!");
      return;
    }
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    //window.open(url, "_blank"); // abre o WhatsApp Web ou app
    window.location.href = url;
  };
  return (
    <div className="content-wrapper">
      <h3>Ajuda</h3>
      <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Ajuda</Breadcrumb.Item>
        </Breadcrumb>
        
        <div style={{ padding: "20px", maxWidth: "400px" }}>
          <h2>Enviar mensagem para WhatsApp</h2>
          <textarea
            rows="4"
            style={{ width: "100%", marginBottom: "10px" }}
            placeholder="Digite sua mensagem aqui..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <button onClick={sendMessage} style={{ padding: "10px 20px" }}>
            Enviar para WhatsApp
          </button>
        </div>
    </div>
  );
};

export default Help;
